import { Component, OnInit } from '@angular/core';
import { EBitfSidenavMode, EBitfSidenavPosition } from '@common/enums';
import { BitfMatSidenavService } from '@common/libs/bitforce/core/services/sidenav/material/bitf-mat-sidenav.service';
import { StoreService } from '@web/core/services';
import { SidenavComponent } from '../sidenav/sidenav.component';
import { BITF_CONFIGS } from '@web/configs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  configs = BITF_CONFIGS;
  constructor(public storeService: StoreService, public bitfMatSidenavService: BitfMatSidenavService) {}

  ngOnInit(): void {}

  onToggleMenuButton() {
    this.bitfMatSidenavService
      .open({
        component: SidenavComponent,
        componentData: {
          brands: this.storeService.store.brands,
        },
        sidenavOptions: {
          mode: EBitfSidenavMode.OVER,
          position: EBitfSidenavPosition.LEFT,
        },
      })
      .subscribe(() => {});
  }

  onMenuItemFocus(event: FocusEvent): void {
    this.menuItemClearHover();
    const target = event.target as HTMLElement;
    const menuItem = target.closest('.primary-menu__item');
    if (menuItem) {
      menuItem.classList.add('hover');
    }
  }

  onMenuItemClick(event: MouseEvent): void {
    this.menuItemClearHover();
    setTimeout(() => {
      const mainContent = document.getElementById('main-content');
      if (mainContent) {
        mainContent.setAttribute('tabindex', '-1');
        mainContent.focus();

        // Remove tabindex after focus to restore natural tab order
        mainContent.addEventListener(
          'blur',
          () => {
            mainContent.removeAttribute('tabindex');
          },
          { once: true }
        );
      }
    }, 100);
  }

  openSubMenu(event: MouseEvent): void {
    event.preventDefault();
    const target = event.target as HTMLElement;
    const menuItem = target.closest('.primary-menu__item');

    if (menuItem) {
      // Close all other menus first
      this.menuItemClearHover();

      menuItem.classList.add('hover');
      const megaMenu = menuItem.querySelector<HTMLElement>('.primary-menu__mega-menu');
      if (megaMenu) {
        megaMenu.setAttribute('aria-hidden', 'false');
        // Make links keyboard navigable
        const links = megaMenu.querySelectorAll<HTMLElement>('a');
        links.forEach(link => link.setAttribute('tabindex', '0'));
      }
    }
  }

  menuItemClearHover(event?: FocusEvent): void {
    let currentElement: Element | null = null;
    if (event) {
      currentElement = (event.target as HTMLElement).closest('.primary-menu__item');
    }

    const menuItems = document.querySelectorAll('.primary-menu__item.hover');
    menuItems.forEach(item => {
      // Skip current item if it matches the focused item
      if (currentElement && item === currentElement) {
        return;
      }

      item.classList.remove('hover');
      const megaMenu = item.querySelector<HTMLElement>('.primary-menu__mega-menu');
      if (megaMenu) {
        megaMenu.setAttribute('aria-hidden', 'true');
        // Remove links from keyboard navigation
        const links = megaMenu.querySelectorAll<HTMLElement>('a');
        links.forEach(link => link.setAttribute('tabindex', '-1'));
      }
    });
  }
}
